import React, { Component } from 'react';
import { MsalProvider, withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import BreadCrumbComponent from '../../bread-crumb/BreadCrumbComponent';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../../AppInsights';
import { IACLService } from '../IACLService';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import Spinner from "../../Spinner";
import AlertMessage from "../../alertmessage/AlertMessage"
import { MessageSeverity, FilterMatchMode, FilterOperator } from 'primereact/api';
import * as Yup from 'yup';

//HDO-5469 - PI 2024 Q3 - Integrate IACL UI features into the Monitoring tool
class MessageContentComponent extends Component {
    constructor() {
        super();
        this.WrappedMessageContentComponent = React.createRef();
        this._isMounted = false;
        this.state = {
            pageErrorMessage: '',
            pageSuccessMessage: '',
            messageContentList: [],
            messageContent: {
                Id: 0,
                MessageContent: null,
                IsActive: false
            },
            MessageContentAuditLogs: [],
            hideSpinner: false,
            showpagination: false,
            editMsgContentDialogBoxVisible: false,
            createMsgContentDialogBoxVisible: false,
            confirmDeleteMsgContentDialogBoxVisible: false,
            msgContentAuditLogDialogBoxVisible: false,
            confirmDeleteVisible: false,
            dt: React.createRef(),
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            globalFilterValue: '',
        }
        this.IACLService = new IACLService();
    }

    componentDidMount() {
        this._isMounted = true;
        this.getAllMessageContent();
    }

    getAllMessageContent = () => {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getAllMessageContent(false, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        this.setState({ messageContentList: d.body, hideSpinner: true, pageSuccessMessage: '', pageErrorMessage: '' });
                        if (this.state.messageContentList.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getMsgContentOpsAuditLog = (rowData) => {
        this.setState({ messageContent: { ...rowData }, hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getMsgContentOpsAuditLog(rowData.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        this.setState({ MessageContentAuditLogs: d.body, hideSpinner: true, msgContentAuditLogDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' });
                        if (this.state.MessageContentAuditLogs.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    editMessageContent = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-book" className="p-button-rounded p-button-outlined" tooltip="Logs" tooltipOptions={{ position: 'top' }} onClick={(e) => this.getMsgContentOpsAuditLog(rowData)} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-primary p-mr-2" tooltip="Edit" tooltipOptions={{ position: 'top' }} onClick={() => this.showEditMsgContentDialog(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Delete" tooltipOptions={{ position: 'top' }} onClick={e => this.setState({ confirmDeleteMsgContentDialogBoxVisible: true, pageErrorMessage: null, pageSuccessMessage: null, messageContent: { ...rowData } })} />
            </React.Fragment>
        );
    }

    showEditMsgContentDialog = (rowData) => {
        this.setState({ messageContent: { ...rowData }, editMsgContentDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' })
    }

    showMsgContentDialogBoxForCreate = () => {
        this.clearRowSelection();
        this.setState({ createMsgContentDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' })
    }

    clearRowSelection() {
        this.setState({
            messageContent: {
                Id: 0,
                MessageContent: null,
                IsActive: null
            },
        })
    }

    handleInputChange = (event) => {
        this.setState({
            messageContent: {
                ...this.state.messageContent, //using spread operator to initialize object with existing props
                [event.target.name]: event.target.value
            },
            pageErrorMessage: null
        });
    }

    validateEditMsgContentDialogFormField = async (messageContent, onSave = false, isCreate = false) => {

        console.log(messageContent)

        if (onSave || isCreate) {
            try {
                let msgContentSchema = Yup.object({
                    MessageContent: Yup.string().required("Message content is required.")
                        .max(50, "Message content cannot be more than 50 characters.")
                        .matches(/^[^'"]*$/, "Message content should not contain single (') or double (\") quotes.")
                });
                await msgContentSchema.validate(messageContent, { abortEarly: false })

                this.setState({ pageErrorMessage: '' });
                this.IsMessageContentExists(isCreate);
            }
            catch (error) {
                this.setState({ pageErrorMessage: error.inner[0].message });
            }
        }
    }

    IsMessageContentExists(isCreate = false) {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' })
        this.IACLService.IsMessageContentExists(this.state.messageContent.MessageContent, this.state.messageContent.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (d.status === 200 && d.body) {
                        this.setState({ pageErrorMessage: 'The message content provided already exists. Please use a different one.', hideSpinner: true });
                    }
                    else {
                        if (isCreate)
                            this.createMessageContent();
                        else
                            this.updateMessageContent();
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    createMessageContent() {
        let body = JSON.stringify(this.state.messageContent);
        this.IACLService.createMessageContent(body, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted && d.status === 200) {
                        this.getAllMessageContent();
                        this.setState({ pageSuccessMessage: 'Message content created successfully', createMsgContentDialogBoxVisible: false, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    updateMessageContent() {
        let body = JSON.stringify(this.state.messageContent);
        this.IACLService.updateMessageContent(this.state.messageContent.Id, body, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else {
                    if (this._isMounted && d.status === 200) {
                        this.getAllMessageContent();
                        this.setState({ pageSuccessMessage: 'Changes saved successfully.', editMsgContentDialogBoxVisible: false, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    saveFooter = (
        <div>
            <Button label='Save' onClick={() => this.validateEditMsgContentDialogFormField(this.state.messageContent, true)} />
            <Button label='Cancel' onClick={e => this.setState({ editMsgContentDialogBoxVisible: false, pageErrorMessage: null })} className='p-button-secondary' />
        </div>
    );

    createFooter = (
        <div>
            <Button label='Create' onClick={() => this.validateEditMsgContentDialogFormField(this.state.messageContent, true, true)} />
            <Button label='Cancel' onClick={e => this.setState({ createMsgContentDialogBoxVisible: false, pageErrorMessage: null })} className='p-button-secondary' />
        </div>
    );

    deleteMessageContent() {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null, hideSpinner: false })
        this.IACLService.deleteMessageContent(this.state.messageContent.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to perform this operation.', confirmDeleteMsgContentDialogBoxVisible: false, hideSpinner: true });
                } else if (d.status === 200 && d.body) {
                    this.setState({ pageSuccessMessage: 'Message content deleted successfully.', confirmDeleteMsgContentDialogBoxVisible: false, hideSpinner: true });
                    this.getAllMessageContent();
                } else if (d.status === 500 && d.body) {
                    this.setState({ pageErrorMessage: d.body.error, confirmDeleteMsgContentDialogBoxVisible: false, hideSpinner: true });
                } else {
                    this.setState({ pageErrorMessage: 'Something went wrong', confirmDeleteMsgContentDialogBoxVisible: false, hideSpinner: true });
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    confirmDeleteFooter = (
        <div>
            <Button label='Ok' onClick={() => this.deleteMessageContent()} />
            <Button label='Cancel' onClick={e => this.setState({ confirmDeleteMsgContentDialogBoxVisible: false })}
                className='p-button-secondary' />
        </div>
    );

    onGlobalFilterChange = (event, filtersKey) => {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null })

        const value = event.target.value;
        let filters = { ...this.state[filtersKey] };
        filters['global'].value = value;

        this.setState({ [`${filtersKey}`]: filters });
    }

    globalSearchFilter = (filtersKey) => {
        return (

            <div>
                <div className="flex justify-content-between" >
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearDataTableFilters} />
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"></i>
                        <InputText type="search" value={this.state[`${filtersKey}`]['global'].value || ''} onChange={(e) => this.onGlobalFilterChange(e, filtersKey)} placeholder="Global Search" size="100" />
                    </span>
                    <span>
                        <Button tooltip='Refresh' tooltipOptions={{ position: 'top' }} onClick={this.getAllMessageContent} icon="pi pi-refresh" />
                    </span>
                </div>
            </div>
        )
    }

    clearDataTableFilters = () => {
        this.setState({
            pageErrorMessage: null,
            pageSuccessMessage: null,
            pageErrorMessage: null,
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            globalFilterValue: '',

        })
        sessionStorage.clear();
    }

    booleanChecker = (rowData) => {
        if (rowData.IsActive) {
            return <span className='masterdata-status-badge status-active'>ACTIVE</span>;
        }
        else {
            return <span className='masterdata-status-badge status-inactive'>INACTIVE</span>;
        }
    };

    onStatusSwitchChange = (e) => {
        this.setState({ messageContent: { ...this.state.messageContent, IsActive: e.value }, pageErrorMessage: null, pageSuccessMessage: null })
    }

    showAlertMessage = (severity, alertMsg) => {
        this.alertMsg.showAlert(severity, alertMsg);
    }

    render() {
        return (
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <div className="messageTypeContainer">
                    <BreadCrumbComponent {...this.props} />

                    <AlertMessage ref={instance => { this.alertMsg = instance }} />
                    {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                    {this.state.pageSuccessMessage ? this.showAlertMessage(MessageSeverity.SUCCESS, this.state.pageSuccessMessage) : <></>}

                    <div hidden={this.state.hideSpinner}>
                        <Spinner />
                    </div>

                    <div>
                        <div className='flex justify-content-between' style={{ marginBottom: '10px' }}>
                            <div className="page-header-title">MESSAGE CONTENT</div>
                            <Button label='' icon='pi pi-plus' tooltip='Create Message Content' tooltipOptions={{ position: 'left' }} onClick={this.showMsgContentDialogBoxForCreate} />
                        </div>

                        <DataTable ref={(el) => this.dt = el} value={this.state.messageContentList}
                            selectionMode="single"
                            filters={this.state.filters}
                            filterDisplay="menu"
                            responsiveLayout="scroll"
                            header={this.globalSearchFilter('filters')}
                            paginator={this.state.showpagination}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50, 100]}
                            emptyMessage="No Records found."
                            showGridlines={true}
                            onFilter={(e) => this.setState({ filters: e.filters })}
                            stateStorage="session" stateKey="dt-messageContent-session"
                        >
                            <Column field="MessageContent" header="Message Content" style={{ textAlign: 'left' }} />
                            <Column field="Status" header="Status" style={{ textAlign: 'left' }} body={this.booleanChecker} />
                            <Column field="edit" header="Action" body={this.editMessageContent} style={{ whiteSpace: 'nowrap', width: '150px', textAlign: 'center' }} alignHeader='center' />
                        </DataTable>
                    </div>

                    <Dialog header='Edit Message Content' footer={this.saveFooter}
                        visible={this.state.editMsgContentDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ editMsgContentDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false}>
                        <div>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                            <table style={{ width: '400px' }}>
                                <tr>
                                    <td>
                                        <label><b>Enable</b></label>
                                        <InputSwitch checked={this.state.messageContent.IsActive} onChange={this.onStatusSwitchChange}
                                            tooltip={this.state.messageContent.IsActive ? 'YES' : 'NO'} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className='required-field'><b>Message Content</b></label>
                                        <InputText type='text' name='MessageContent' value={this.state.messageContent.MessageContent || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Dialog>

                    <Dialog header='Create Message Content' footer={this.createFooter}
                        visible={this.state.createMsgContentDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ createMsgContentDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false}>
                        <div>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                            <table style={{ width: '400px' }}>
                                <tr>
                                    <td>
                                        <label><b>Enable</b></label>
                                        <InputSwitch checked={this.state.messageContent.IsActive} onChange={this.onStatusSwitchChange}
                                            tooltip={this.state.messageContent.IsActive ? 'YES' : 'NO'} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className='required-field'><b>Message Content</b></label>
                                        <InputText type='text' name='MessageContent' value={this.state.messageContent.MessageContent || ''} required
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Dialog>

                    <Dialog header='Delete Message Content' footer={this.confirmDeleteFooter}
                        visible={this.state.confirmDeleteMsgContentDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ confirmDeleteMsgContentDialogBoxVisible: false })} maximizable={false}>
                        <div>
                            Are you sure you want to delete the message content <b>{this.state.messageContent.MessageContent}</b>?
                        </div>
                    </Dialog>

                    <Dialog header={this.state.messageContent.MessageContent + ' - Audit Logs'} style={{ width: '40vw' }}
                        visible={this.state.msgContentAuditLogDialogBoxVisible} modal={true}
                        onHide={e => this.setState({ msgContentAuditLogDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false} closeOnEscape={true}>
                        <div>
                            <DataTable value={this.state.MessageContentAuditLogs}
                                selectionMode="single"
                                paginator={true}
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                filterDisplay="menu"
                                responsiveLayout="scroll"
                                showGridlines removableSort
                                emptyMessage="No Records found."
                                sortField='Timestamp' sortOrder="-1"
                            >
                                <Column field="DisplayTimestamp" header="Timestamp" style={{ textAlign: 'left' }} sortable sortField='Timestamp' />
                                <Column field="ActionType" header="Action" style={{ textAlign: 'left' }} />
                                <Column field="ActionBy" header="Action By" style={{ textAlign: 'left' }} />
                            </DataTable>
                        </div>
                    </Dialog>

                </div>
            </MsalAuthenticationTemplate>
        )
    }
}

const WrappedMessageContentComponent = withMsal(MessageContentComponent);
export default withAITracking(reactPlugin, WrappedMessageContentComponent);